/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getCaseShallow = /* GraphQL */ `query GetCaseShallow($id: ID!) {
    getCase(id: $id) {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      templateData
      typedNotes
      recordings {
        items {
          id
          name
          storagePath
          text
          summary
          segments
          lID
          cID
          owners
          createdAt
          _version
          _deleted
        }
      }
      details {
        items {
          id
          type
          text
          summary
          isSummarized
          patient {
            id
            name
            client
            image
            s3Image
            lID
            groups
            owners
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          pID
          groups
          owners
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      caseTemplateId
      __typename
    }
  }
  ` as GeneratedQuery<APITypes.GetCaseQueryVariables, APITypes.GetCaseQuery>;